export const issueSeverityEnum = {
  WARNING: 'WARNING',
  ERROR: 'ERROR',
} as const

export type IssueSeverityEnum = (typeof issueSeverityEnum)[keyof typeof issueSeverityEnum]

export type IssueSeverity = IssueSeverityEnum